  import React, { useEffect, useRef, useState } from "react";

  const GenericTableHeader = ({disableSort, sortState , columns, onResize,updateSortKey,updateSortConfig,allowSelection=false,toggleSelectAll,allowAllSelect=false,isIndeterminate ,isAllSelected}) => {
    const [resizingIndex, setResizingIndex] = useState(null);

    const handleMouseDown = (index, e) => {
      e.preventDefault();
      e.stopPropagation();
      setResizingIndex(index);
      onResize(index, e);

      const handleMouseUp = () => {
        setResizingIndex(null);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mouseup", handleMouseUp);
    };



    const getSortIndicator = (colId) => {
      if (sortState?.sortKey !== colId) return "";
      const order = sortState?.sortConfig?.order;
      console.log("getSortIndicator ",order)
      if (order === "asc") return " ↑";
      if (order === "desc") return " ↓";
      return "";
    };
 // ✅ Proper indeterminate handling via ref + effect
  const headerCheckboxRef = useRef(null);
  useEffect(() => {
    // console.log("sapnadip",headerCheckboxRef.current.indeterminate,isIndeterminate)
    if (headerCheckboxRef?.current) {
      headerCheckboxRef.current.indeterminate = isIndeterminate;
    }
  }, [headerCheckboxRef?.current?.indeterminate,isIndeterminate]);



    return (
      <>
        {columns?.map((col, index) => {
          // If the key is "generic-check-box", render the checkbox header
          if (allowSelection && col?.id === "generic-check-box") {
           return (
                <>
                  {allowAllSelect ?(
                    <th key={col.id}>
                      <input
                        ref={headerCheckboxRef}
                        type="checkbox"
                        checked={isAllSelected}
                        aria-checked={isIndeterminate ? "mixed" : isAllSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                  ):  <th key={col.id}>
                     
                    </th>}
                </>
              );
          }

          // Otherwise render the standard header cell
          return (
            <th
              key={col.id}
              style={{ width: col.width, maxWidth: col.width }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!disableSort && !col?.disableColSort) {
                  updateSortKey(col.id);
                  updateSortConfig(
                    sortState?.sortConfig?.order === "asc" ? "desc" : "asc"
                  );
                }
              }}
            >
              <div
                className="custom-resizable-table-th-content"
                style={{
                  display: "flex",
                  justifyContent: col?.alignment || "center",
                  alignItems: "center",
                }}
              >
                <span className="column-label">{col.label}</span>
                {!disableSort && !col?.disableColSort && (
                  <span className="sort-indicator">
                    {" "}
                    {getSortIndicator(col.id)}
                  </span>
                )}
              </div>

              <span
                className={`generic-table-header-resizer ${
                  resizingIndex === index ? "visible" : ""
                }`}
                onMouseDown={(e) => handleMouseDown(index, e)}
              />
            </th>
          );
        })}
      </>
    );

  };

  export default GenericTableHeader;
